/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 19/7/2024
 */

import { Edit } from "@mui/icons-material";
import { Box, ButtonGroup, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { openNotificationForm, setNotificationStatus, setSelectedNotification } from "../../Store/Slices/notificationSlice";
import { PaginationDetails } from "../../Utils/Utils";

const NotificationTable = ({ data }) => {

    const dispatch = useDispatch();
    const [roles, setRoles] = useState("")
    const { page, count, handleChange, _DATA } = PaginationDetails(data);

    useEffect(() => {
      const getRoles = () => {
        if (typeof window !== undefined) {
          setRoles(sessionStorage.getItem("roles"));
        }
      }
      getRoles()
    }, [])

    const handleEditClick = (id) => {
        dispatch(openNotificationForm(true)); 
        dispatch(setSelectedNotification(id)); 
        dispatch(setNotificationStatus('edit'))
    };

    return (  
        <>
            <TableContainer>
                <Table stickyHeader aria-label="simple table" sx={{ height: "max-content" }}>
                    <TableHead>
                        <TableRow>
                            <TableCell width={50}>Notification Number</TableCell>
                            <TableCell width={200}>Notification Name</TableCell>
                            <TableCell align="center" width={'30%'}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {_DATA.currentData().map((notification) => (
                            <TableRow sx={{ height: '30px' }} key={notification.notiId}>
                                <TableCell component="th" scope="row" sx={{ borderBottom: "none", fontWeight: 'bold', width: 100, height: 'auto !important' }}>
                                    #{notification.notiId}
                                </TableCell>
                                <TableCell sx={{ borderBottom: "none", width: 50, height: 'auto !important' }}>{notification.notiName}</TableCell>
                                <TableCell align="center" sx={{ borderBottom: "none", width: '30%', height: 'auto !important' }}>
                                    <ButtonGroup variant="text" aria-label="text button group">
                                        {roles?.split(",").includes("PRIV_ES_EDITNOTIFICATION") && <IconButton aria-label="edit" onClick={() => { handleEditClick(notification.notiId) }}>
                                            <Edit />
                                        </IconButton>}
                                    </ButtonGroup>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box my={2} display="flex" justifyContent="center">
                <Pagination
                    count={count}
                    size="large"
                    page={page}
                    variant="outlined"
                    color="primary"
                    onChange={handleChange}
                    style={{ justifyContent: 'center', right: 0 }}
                />
            </Box>
        </>
    );
}

export default NotificationTable;